import { FecImportLifecycleStatus } from '../enums/fecImportLifecycleStatus'
import { FecMappingReviewStatus } from '../enums/fecMappingReviewStatus'
import type { FecImportItem } from '../query-api'

type FecImportOpenFields = Pick<
  FecImportItem,
  'accountMappingStatus' | 'journalMappingStatus' | 'status' | 'thirdPartyMappingStatus'
>

// Past the part the wizard walks through: the mappings are confirmed and on their way to Billy (or done).
const FINISHED_STATUSES: ReadonlySet<FecImportLifecycleStatus> = new Set([
  FecImportLifecycleStatus.Done,
  FecImportLifecycleStatus.PushFailed,
  FecImportLifecycleStatus.PushingToBilly,
])

/**
 * Whether the wizard still has something to do with an import. Journals, accounts and third parties are the domains
 * the wizard walks through, so once all three are confirmed the import is finished from its point of view, even
 * though the backend keeps it open until every domain is pushed. A domain that failed to confirm keeps it open.
 */
export const isFecImportOpenForWizard = ({
  accountMappingStatus,
  journalMappingStatus,
  status,
  thirdPartyMappingStatus,
}: FecImportOpenFields): boolean =>
  !FINISHED_STATUSES.has(status) &&
  ![journalMappingStatus, accountMappingStatus, thirdPartyMappingStatus].every(
    (mappingStatus) => mappingStatus === FecMappingReviewStatus.Confirmed,
  )
